import Link from "next/link"
import { BlitzPage, Routes } from "@blitzjs/next"
import Layout from "app/core/layouts/Layout"
import Footer from "components/footer"
import dynamic from "next/dynamic"
// Dynamic import to avoid SSR and hydration errors
const Header = dynamic(() => import("components/header"), { ssr: false })
import { STATIC_ASSETS_CLOUDFRONT_URL } from "app/constants"

const Stories: BlitzPage = () => {
  return (
    <div className="min-h-screen">
      <section
        style={{
          backgroundImage: `url(${STATIC_ASSETS_CLOUDFRONT_URL}/Parcel_Tree_Banner_DarkerGr_gdt.jpg)`,
          backgroundSize: "cover",
          backgroundPosition: "center center",
          backgroundRepeat: "no-repeat",
          imageRendering: "crisp-edges",
        }}
      >
        <div className="bg-white">
          <Header />
        </div>
        <div className="m-auto w-4/5 pb-20 pt-32">
          <div>
            <p className="pb-2 text-3xl font-medium text-white md:leading-snug lg:text-[40px] xl:text-[46px]">
              Tree Equity Stories
            </p>
            <p className="text-2xl font-light text-white md:leading-snug">
              Insights and perspectives on Tree Equity Score.
            </p>
          </div>
        </div>
      </section>
      <section className="bg-gradient-to-b from-white to-[#ECF5F2]">
        <div className="h-10"></div>

        {/* Story - Austin Shade */}
        <div>
          <div className="m-auto w-11/12 border-b-2 border-solid border-gray-200 pb-10 pt-10 lg:w-4/5 xl:w-3/5">
            <div className="grid md:grid-cols-3">
              <div className="m-auto w-1/2 md:w-1/2">
                {" "}
                <Link href={Routes.AustinShadeStory()} className="cursor-pointer">
                  <img
                    className="rounded-full object-cover"
                    src={`${STATIC_ASSETS_CLOUDFRONT_URL}/stories/aus_decal.jpg`}
                    alt=""
                  />
                </Link>
              </div>
              <div className="m-auto mt-0 w-3/4 text-center text-base font-medium leading-snug text-gray-700 md:col-span-2 md:w-11/12 md:pl-5 md:text-left lg:text-base xl:text-lg">
                <p className="pt-6 text-2xl xl:text-3xl">
                  Austin TX - School Routes Aren't the Coolest
                </p>
                <p className="w-11/12 pt-2 text-lg">
                  How hot is your route to school? We analyzed shade along school routes in Austin
                  to find out.
                </p>
                <Link href={Routes.AustinShadeStory()}>
                  <div className="mt-3 inline-block cursor-pointer text-sm font-bold uppercase text-brand-green-dark hover:text-brand-green">
                    Read it now
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Story - Detroit Shade */}
        <div>
          <div className="m-auto w-11/12 border-b-2 border-solid border-gray-200 pb-10 pt-10 lg:w-4/5 xl:w-3/5">
            <div className="grid md:grid-cols-3">
              <div className="m-auto w-1/2 md:w-1/2">
                {" "}
                <Link href={Routes.DetroitShadeStory()} className="cursor-pointer">
                  <img
                    className="rounded-full object-cover"
                    src={`${STATIC_ASSETS_CLOUDFRONT_URL}/stories/det_decal.jpg`}
                    alt=""
                  />
                </Link>
              </div>
              <div className="m-auto mt-0 w-3/4 text-center text-base font-medium leading-snug text-gray-700 md:col-span-2 md:w-11/12 md:pl-5 md:text-left lg:text-base xl:text-lg">
                <p className="pt-6 text-2xl xl:text-3xl">
                  Detroit MI - Cooling Detroit's Bus Stops
                </p>
                <p className="w-11/12 pt-2 text-lg">
                  Most public transit stops in Detroit are exposed to scorching heat in the
                  summertime. State-of-the-art shade data can guide smart investments that improve
                  walkability and make Detroit a cooler place to live and visit.
                </p>
                <Link href={Routes.DetroitShadeStory()}>
                  <div className="mt-3 inline-block cursor-pointer text-sm font-bold uppercase text-brand-green-dark hover:text-brand-green">
                    Read it now
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Story - Phoenix Shade */}
        <div>
          <div className="m-auto w-11/12 border-b-2 border-solid border-gray-200 pb-10 pt-10 lg:w-4/5 xl:w-3/5">
            <div className="grid md:grid-cols-3">
              <div className="m-auto w-1/2 md:w-1/2">
                {" "}
                <Link href={Routes.PhoenixShadeStory()} className="cursor-pointer">
                  <img
                    className="rounded-full object-cover"
                    src={`${STATIC_ASSETS_CLOUDFRONT_URL}/stories/phx_decal.jpg`}
                    alt=""
                  />
                </Link>
              </div>
              <div className="m-auto mt-0 w-3/4 text-center text-base font-medium leading-snug text-gray-700 md:col-span-2 md:w-11/12 md:pl-5 md:text-left lg:text-base xl:text-lg">
                <p className="pt-6 text-2xl xl:text-3xl">
                  Phoenix AZ - Beating the Heat in Public Parks
                </p>
                <p className="w-11/12 pt-2 text-lg">
                  The City of Phoenix is leading the way to cool its neighborhoods and make public
                  spaces safer year round. Learn how cutting-edge shade data is turning plans into
                  action.
                </p>
                <Link href={Routes.PhoenixShadeStory()}>
                  <div className="mt-3 inline-block cursor-pointer text-sm font-bold uppercase text-brand-green-dark hover:text-brand-green">
                    Read it now
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Story - Next Generation */}
        <div>
          <div className="m-auto w-11/12 border-b-2 border-solid border-gray-200 pb-10 pt-10 lg:w-4/5 xl:w-3/5">
            <div className="grid md:grid-cols-3">
              <div className="m-auto w-1/2 md:w-1/2">
                {" "}
                <Link href={Routes.TES2UpdatesStory()} className="cursor-pointer">
                  <img
                    className="rounded-full object-cover"
                    src="/ds-next-gen-story-img.jpg"
                    alt=""
                  />
                </Link>
              </div>
              <div className="m-auto mt-0 w-3/4 text-center text-base font-medium leading-snug text-gray-700 md:col-span-2 md:w-11/12 md:pl-5 md:text-left lg:text-base xl:text-lg">
                <p className="pt-6 text-2xl xl:text-3xl">Tree Equity Score - The Next Generation</p>
                <p className="w-11/12 pt-2 text-lg">
                  The next generation of Tree Equity Score is here. And it's better than ever...
                  Take a tour and find out what's new.
                </p>
                <Link href={Routes.TES2UpdatesStory()}>
                  <div className="mt-3 inline-block cursor-pointer text-sm font-bold uppercase text-brand-green-dark hover:text-brand-green">
                    Read it now
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Story - NTC Story */}
        <div>
          <div className="m-auto w-11/12 pt-10 lg:w-4/5 xl:w-3/5">
            <div className="grid md:grid-cols-3">
              <div className="m-auto w-1/2 md:w-1/2">
                {" "}
                <Link href={Routes.NTCStory()} className="cursor-pointer">
                  <img
                    className="rounded-full object-cover"
                    src={`${STATIC_ASSETS_CLOUDFRONT_URL}/ntc_stories_pg.jpg`}
                    alt=""
                  />
                </Link>
              </div>
              <div className="m-auto mt-0 w-3/4 text-center text-base font-medium leading-snug text-gray-700 md:col-span-2 md:w-11/12 md:pl-5 md:text-left lg:text-base xl:text-lg">
                <p className="pt-6 text-2xl xl:text-3xl">Tree Equity Score in Action</p>
                <p className="w-11/12 pt-2 text-lg">
                  Newport Tree Conservancy: The non-profit on a mission to bring Tree Equity to
                  Newport, Rhode Island.
                </p>
                <Link href={Routes.NTCStory()}>
                  <div className="mt-3 inline-block cursor-pointer text-sm font-bold uppercase text-brand-green-dark hover:text-brand-green">
                    Read it now
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Story - PNPP Story */}
        <div>
          <div className="m-auto h-10 w-11/12 border-b-2 border-solid border-gray-200 lg:w-4/5 xl:w-3/5"></div>
          <div className="m-auto w-11/12 pt-10 lg:w-4/5 xl:w-3/5">
            <div className="grid md:grid-cols-3">
              <div className="m-auto w-1/2 md:w-1/2">
                {" "}
                <Link href={Routes.PNPPStory()} className="cursor-pointer">
                  <img
                    className="rounded-full object-cover"
                    src={`${STATIC_ASSETS_CLOUDFRONT_URL}/pnpp_stories_pg.jpg`}
                    alt=""
                  />
                </Link>
              </div>
              <div className="m-auto mt-0 w-3/4 text-center text-base font-medium leading-snug text-gray-700 md:col-span-2 md:w-11/12 md:pl-5 md:text-left lg:text-base xl:text-lg">
                <p className="pt-6 text-2xl xl:text-3xl">Unlocking Tree Equity Score</p>
                <p className="w-11/12 pt-2 text-lg">
                  How a Providence, Rhode Island non-profit is partnering with their community to
                  take Tree Equity to the next level.
                </p>
                <Link href={Routes.PNPPStory()}>
                  <div className="mt-3 inline-block cursor-pointer text-sm font-bold uppercase text-brand-green-dark hover:text-brand-green">
                    Read it now
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Story - Happier and Healthier */}
        <div>
          <div className="m-auto h-10 w-11/12 border-b-2 border-solid border-gray-200 lg:w-4/5 xl:w-3/5"></div>
          <div className="m-auto w-11/12 pt-10 lg:w-4/5 xl:w-3/5">
            <div className="grid md:grid-cols-3">
              <div className="m-auto w-1/2 md:w-1/2">
                {" "}
                <Link href={Routes.HappierHealthierStory()} className="cursor-pointer">
                  <img className="rounded-full object-cover" src="/mh-storyimg.png" alt="" />
                </Link>
              </div>
              <div className="m-auto mt-0 w-3/4 text-center text-base font-medium leading-snug text-gray-700 md:col-span-2 md:w-11/12 md:pl-5 md:text-left lg:text-base xl:text-lg">
                <p className="pt-6 text-2xl xl:text-3xl">Happier and Healthier</p>
                <p className="w-11/12 pt-2 text-lg">
                  Tree Equity Score data reveals that mental health complaints decline in
                  neighborhoods with more trees.
                </p>
                <Link href={Routes.HappierHealthierStory()}>
                  <div className="mt-3 inline-block cursor-pointer text-sm font-bold uppercase text-brand-green-dark hover:text-brand-green">
                    Read it now
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Story - Urban Heat Equity*/}
        <div>
          <div className="m-auto h-10 w-11/12 border-b-2 border-solid border-gray-200 lg:w-4/5 xl:w-3/5"></div>
          <div className="m-auto w-11/12 pt-10 lg:w-4/5 xl:w-3/5">
            <div className="grid md:grid-cols-3">
              <div className="m-auto w-1/2 md:w-1/2">
                {" "}
                <Link href={Routes.UrbanHeatEquityStory()} className="cursor-pointer">
                  <img
                    className="rounded-full object-cover"
                    src="/heateq-cityfountain-sq.png"
                    alt=""
                  />
                </Link>
              </div>
              <div className="m-auto mt-0 w-3/4 text-center text-base font-medium leading-snug text-gray-700 md:col-span-2 md:w-11/12 md:pl-5 md:text-left lg:text-base xl:text-lg">
                <p className="pt-6 text-2xl xl:text-3xl">Urban Heat Equity</p>
                <p className="w-11/12 pt-2 text-lg">
                  Extreme heat disproportionately impacts people of color and low-income communities
                  across the nation.
                </p>
                <Link href={Routes.UrbanHeatEquityStory()}>
                  <div className="mt-3 inline-block cursor-pointer text-sm font-bold uppercase text-brand-green-dark hover:text-brand-green">
                    Read it now
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="bg-[#ECF5F2]">
        {/* Story - Keeping Cool*/}
        <div>
          <div className="m-auto h-10 w-11/12 border-b-2 border-solid border-gray-200 lg:w-4/5 xl:w-3/5"></div>
          <div className="m-auto w-11/12 pt-10 lg:w-4/5 xl:w-3/5">
            <div className="grid md:grid-cols-3">
              <div className="m-auto w-1/2 md:w-1/2">
                {" "}
                <Link href={Routes.KeepingCoolStory()} className="cursor-pointer">
                  <img
                    className="rounded-full object-cover"
                    src={`${STATIC_ASSETS_CLOUDFRONT_URL}/uheat-minne-heat.jpg`}
                    alt=""
                  />
                </Link>
              </div>
              <div className="m-auto mt-0 w-3/4 text-center text-base font-medium leading-snug text-gray-700 md:col-span-2 md:w-11/12 md:pl-5 md:text-left lg:text-base xl:text-lg">
                <p className="pt-6 text-2xl xl:text-3xl">Keeping Cool</p>
                <p className="w-11/12 pt-2 text-lg">
                  Trees can moderate urban heat in your city. Explore our findings city by city.
                </p>
                <Link href={Routes.KeepingCoolStory()}>
                  <div className="mt-3 inline-block cursor-pointer text-sm font-bold uppercase text-brand-green-dark hover:text-brand-green">
                    Read it now
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Page Bottom */}
        <div className="m-auto h-10 w-11/12 border-b-2 border-solid border-gray-200 lg:w-4/5 xl:w-3/5"></div>
        <div className="h-20"></div>
        <div className="m-auto w-11/12 lg:w-4/5 xl:w-3/5">
          <div>
            <p className="pt-5 text-center text-sm text-brand-green-dark">
              American Forests data shorts are made possible by{" "}
              <img src="/zendesk-horiz-dkgr.png" className="inline h-12" />
            </p>
          </div>
        </div>
        <div className="h-20"></div>
      </section>
      <Footer />
    </div>
  )
}

Stories.getLayout = (page) => <Layout title={"Stories"}>{page}</Layout>
export default Stories
